const breakpoints = {
  values: {
    xs: 0,
    sm: 360,
    md: 480,
    lg: 600,
    xl: 720,
    x2l: 960,
    x3l: 1280,
    x4l: 1600,
  },
};

export default breakpoints;
